import { apiClient } from './api';
import { MultiJournalismRequest, MultiJournalismResponse } from '../models/journalism';

export class JournalismService {
  static async generateArticle(request: MultiJournalismRequest): Promise<MultiJournalismResponse> {
    const response = await apiClient.post('/api/multi-agent/journalism/start', request);
    return response.data;
  }
}

export default JournalismService;